module.exports = function(bootstrap) {
	'use strict';
    bootstrap.run(['Service', '$q', function (Service, $q) {
        return new Service({

            name: 'validatePcp',
            group: 'rbsmbl',
            url: '/rbsmbl/x-services/providerInfo/validate',
            cache: false,

            fetch: function(payload) {
				var deferred = $q.defer();

				//return this.post({ payload: payload });

                this.post({ payload: payload }).then(
					function(response) {
						if (response && response.data && response.data.payload) {
							if (Object.keys(response.data.payload).length) {
								if (response.data.payload.statusMessage) {
									deferred.resolve(response);
								}
								else {
									deferred.resolve(response);
								}
							}
							else {
								deferred.reject({ data: { returnCodeDescription: 'Please enter a valid Provider Number' }});
							}
						}
						else {
							deferred.reject(response);
						}
					},
					function(error) {
						deferred.reject(error);
					}
				);
				return deferred.promise;
            }
        });
    }]);
};
